window.Studio407 = window.Studio407 || {};

(function(Studio) {
  'use strict';

  Studio.renderGallery = function() {
    const grid = document.getElementById('studio-gallery-grid');

    if (!grid) return;

    grid.innerHTML = '';

    Studio.state.slots.forEach(function(slot) {
      grid.insertAdjacentHTML(
        'beforeend',
        `
          <div class="studio-gallery__card" data-slot-id="${slot.id}">
            ${
              slot.image
                ? `<img src="${slot.image}" class="studio-gallery__image" alt="Uploaded photo">`
                : `<div class="studio-gallery__empty" data-add-photo="${slot.id}">
                     <span>+</span>
                     <small>Add Photo</small>
                   </div>`
            }
          </div>
        `
      );
    });

    const completedCount = Studio.state.slots.filter(function(slot) {
      return Boolean(slot.image);
    }).length;

    const completed = document.querySelector(
      '.studio-gallery__progress strong'
    );

    const total = document.getElementById('studio-gallery-total');

    const continueButton = document.querySelector(
      '.studio-gallery__continue'
    );

    if (completed) {
      completed.textContent = completedCount;
    }

    if (total) {
      total.textContent = Studio.state.setSize;
    }

    if (continueButton) {
      const isComplete = completedCount >= Studio.state.setSize;

      continueButton.disabled = !isComplete;
      continueButton.classList.toggle('is-active', isComplete);
    }
  };

  Studio.renderPreview = function() {
    const grid = document.getElementById('studio-preview-grid');

    if (!grid) return;

    grid.innerHTML = '';

    Studio.state.slots.forEach(function(slot) {
      if (!slot.image) return;

      grid.insertAdjacentHTML(
        'beforeend',
        `
          <div class="studio-preview__item">
            <img src="${slot.image}" alt="Preview magnet">
          </div>
        `
      );
    });
  };
})(window.Studio407);
